import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/seo-services/seo-partner.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} xl={7} xxl={7} className="">
            <h2>
              You’ve Discovered the <span>SEO Partner</span> You’ve Been Looking
              For
            </h2>
            <p>
              TekRevol offers the SEO strategies you need to outshine your
              competitors. Don’t wait any longer—let's elevate your online
              presence and get your business noticed!
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Boost My Leads Now
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
